import React from "react";
import Header from "../Header/header";
import { useSelector } from "react-redux";

const IframeView = ({  title = "FatakPay", companyName = "My Company" }) => {

  const url = useSelector((state) => state?.aa?. fatakpayUrl)

  return (
    <div className="max-w-[400px] w-full mx-auto border border-gray-300 rounded-lg overflow-hidden shadow">
      
      {/* Header */}
      <div className=" text-white py-3 px-4 text-lg font-semibold">
       <Header/>
      </div>

      {/* Iframe */}
      <iframe
        src={url}
        title={title}
        className="w-full h-[calc(100vh-60px)] border-0"
      ></iframe>
    </div>
  );
};

export default IframeView;
